export default __webpack_public_path__ + "static/eth-a85b6de0dc4a013ae2f825cfd0826d1b.png";